import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProcessDocumentService {
    private http = inject(HttpClient);
    private url = Global.url;

    getProcesses(): Observable<any[]> {
        return this.http.get<any[]>(`${this.url}V1/process-documents`);
    }

    getRequirementsByProcess(processSlug: string): Observable<any[]> {
        return this.http.get<any[]>(`${this.url}V1/process-documents/${processSlug}/requirements`);
    }

    saveRequirementsBulk(processSlug: string, requirements: any[], options?: { applyToOpen?: boolean }): Observable<any> {
        return this.http.post<any>(`${this.url}V1/process-documents/bulk-requirements`, {
            processSlug,
            requirements,
            applyToOpen: !!options?.applyToOpen
        });
    }

    saveStatusFlowBulk(processId: number, flows: any[]): Observable<any> {
        return this.http.post<any>(`${this.url}V1/process-documents/bulk-status-flow`, { processId, flows });
    }

    createProcess(data: any): Observable<any> {
        return this.http.post<any>(`${this.url}V1/process-documents`, data);
    }

    updateDocumentTypeStatus(slug: string, isActive: boolean): Observable<any> {
        return this.http.put<any>(`${this.url}V1/process-documents/document-type/${slug}/status`, { isActive });
    }

    updateDocumentType(slug: string, patch: { isActive?: boolean; allowExpiration?: boolean }): Observable<any> {
        return this.http.put<any>(`${this.url}V1/process-documents/document-type/${slug}/status`, patch);
    }

    getDocumentTypes(): Observable<any[]> {
        return this.http.get<any[]>(`${this.url}V1/document-types`);
    }

    getDocumentOwners(): Observable<any[]> {
        return this.http.get<any[]>(`${this.url}V1/document-owners`);
    }

    getDocumentCategories(): Observable<any[]> {
        return this.http.get<any[]>(`${this.url}V1/document-categories`);
    }

    syncRequirements(processSlug: string): Observable<any> {
        return this.http.post<any>(`${this.url}V1/process-documents/${processSlug}/sync`, {});
    }

    createDocumentType(data: any): Observable<any> {
        return this.http.post<any>(`${this.url}V1/document-types`, data);
    }
}
